import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "wrh-input-label mb-2 text-wrh-gray-medium"
}, "First Name", -1)
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "wrh-input-label mb-2 text-wrh-gray-medium"
}, "Last Name", -1)
const _hoisted_6 = {
  key: 0,
  class: "relative"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "wrh-input-label mb-2 text-wrh-gray-medium",
  for: "cellPhone"
}, "Phone Number", -1)
const _hoisted_8 = {
  key: 1,
  class: "relative"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "wrh-input-label mb-2 text-wrh-gray-medium",
  for: "HomePhoneNumber"
}, "Home Phone Number", -1)
const _hoisted_10 = {
  key: 2,
  class: "relative"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "wrh-input-label mb-2 text-wrh-gray-medium",
  for: "WorkPhoneNumber"
}, "Work Phone Number", -1)
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "wrh-input-label mb-2 text-wrh-gray-medium",
  for: "email"
}, "Email Address", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-wrh-gray-medium" }, [
  /*#__PURE__*/_createTextVNode(" To update your contact information, please contact the MyHome24-7 Support team at "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:admin@wmryan.com",
    class: "text-wrh-blue-light"
  }, "admin@wmryan.com")
], -1)

import {
  ref, PropType, toRefs, watch,
} from 'vue';
import { useRouter } from 'vue-router';
import { getAuth } from 'firebase/auth';
import { validateContactData } from '../services/service';
import { Collections, Response, Routes } from '@/constants';
import { updateFirestoreRecord } from '@/core/user';
import { Homebuyer } from '@/models';
import { defaultUserImages } from '@/util/placeholders';
import UserAvatar from '@/components/UserAvatar.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  homeBuyer: {
    type: Object as PropType<Homebuyer>,
    required: true,
  },
},
  emits: ['showAlert'],
  setup(__props, { emit }) {

const props = __props


const { homeBuyer } = toRefs(props);
const buyer = ref<Homebuyer>({} as Homebuyer);
buyer.value = homeBuyer.value;
const errors = ref<Record<string, unknown>>({});
const loading = ref(false);

const router = useRouter();

const showModal = (modalType: Response) => {
  emit('showAlert', modalType);
};

const validateData = (
  firstName: string,
  lastName: string,
  phoneNumber: string,
) => {
  const validationError = validateContactData(firstName, lastName, phoneNumber);
  if (Object.keys(validationError).length) {
    errors.value = validationError;
  }
};

const updateContactInfo = async () => {
  if (getAuth().currentUser) {
    const {
      uid, firstName, lastName, mobilephone,
    } = buyer.value;
    loading.value = true;
    const status = await updateFirestoreRecord(Collections.HOMEBUYERS, uid!, {
      firstName,
      lastName,
      mobilephone,
    });
    loading.value = false;
    showModal(status as Response);
  } else {
    router.push({ name: Routes.LOGIN });
  }
};

const submit = async () => {
  errors.value = {};
  const { firstName, lastName, mobilephone } = buyer.value;
  validateData(firstName, lastName, mobilephone);

  if (!Object.keys(errors.value).length) {
    updateContactInfo();
  }
};

const handleImageError = (event: Event) => {
  (event.target as HTMLImageElement).src = defaultUserImages();
};

watch(homeBuyer, (value) => {
  buyer.value = value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "lg:w-1/2 space-y-6 items-center lg:block space-y-6",
    onSubmit: _withModifiers(submit, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        id: "firstName",
        class: _normalizeClass([
          'wrh-input border-wrh-gray-extralight text-wrh-gray-medium',
          { 'border-red-600': Object.keys(errors.value).length && errors.value.firstname },
        ]),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (buyer.value.firstName = $event)),
        disabled: ""
      }, null, 2), [
        [_vModelText, buyer.value.firstName]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: _normalizeClass([
          'wrh-input border-wrh-gray-extralight text-wrh-gray-medium',
          { 'border-red-600': Object.keys(errors.value).length && errors.value.lastname },
        ]),
        id: "lastName",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (buyer.value.lastName = $event)),
        disabled: ""
      }, null, 2), [
        [_vModelText, buyer.value.lastName]
      ])
    ]),
    (buyer.value.mobilephone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass([
          'wrh-input border-wrh-gray-extralight text-wrh-gray-medium',
          {
            'border-red-600': Object.keys(errors.value).length && errors.value.phonenumber,
          },
        ]),
            id: "cellPhone",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (buyer.value.mobilephone = $event)),
            disabled: ""
          }, null, 2), [
            [_vModelText, buyer.value.mobilephone]
          ])
        ]))
      : _createCommentVNode("", true),
    (buyer.value.homephone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "wrh-input border-wrh-gray-extralight text-wrh-gray-medium",
            id: "HomePhoneNumber",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (buyer.value.homephone = $event)),
            disabled: ""
          }, null, 512), [
            [_vModelText, buyer.value.homephone]
          ])
        ]))
      : _createCommentVNode("", true),
    (buyer.value.workphone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "wrh-input border-wrh-gray-extralight text-wrh-gray-medium",
            id: "WorkPhoneNumber",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (buyer.value.workphone = $event)),
            disabled: ""
          }, null, 512), [
            [_vModelText, buyer.value.workphone]
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "wrh-input border-wrh-gray-extralight text-wrh-gray-medium",
        id: "email",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (buyer.value.email = $event)),
        novalidate: "",
        disabled: ""
      }, null, 512), [
        [_vModelText, buyer.value.email]
      ])
    ]),
    _hoisted_14
  ], 40, _hoisted_1))
}
}

})